module.exports = {
  "notification": {},
}



// WEBPACK FOOTER //
// ./src/i18n/notification/en.js